import React, {memo} from "react"

const LoadingActivitiesAndBooked = memo(()=>{
	return (<div>
		{[1,2,1,1].map((n,i) => (
			<div key={i} className="grid grid-cols-3 gap-0 p-4 relative animate-pulse">
				<div className="text-center flex justify-end">
					{n % 2 === 0 && (
						<>
							<div>
								<div className="w-16 h-4 bg-gray-200 rounded-full"></div>
								<div className="w-12 h-4 bg-gray-200 rounded-full mt-2"></div>
							</div>
							<div className="animate-pulse flex space-x-4">
								<div className="rounded-full bg-gray-200 h-10 w-10"></div>
							</div>
						</>
					)}
				</div>
				<div>
					<div className="text-center flex items-center">
						<div className={`transform ${n % 2 === 0 ? "-translate-x-1/2" : "translate-x-1/2"}border-b border-2 border-solid w-1/6 mx-auto mt-6 transition-all duration-400 ease-in-out`}></div>
						<div className="absolute top-0 bottom-0 left-1/2 transform -translate-x-1/2 border-2 border-r border-solid"></div>
					</div>
				</div>
				<div>
					{n % 2 !== 0 && (
						<div className="text-center flex">
							<div className="rounded-full bg-gray-200 h-10 w-10"></div>
							<div>
								<div className="w-16 h-4 bg-gray-200 rounded-full"></div>
								<div className="w-12 h-4 bg-gray-200 rounded-full mt-2"></div>
							</div>
						</div>
					)}
				</div>
			</div>
		))}
	</div>)
})

export default LoadingActivitiesAndBooked;